import React, { type ReactNode } from 'react';
import Typography from '@mui/material/Typography';

import { Flex, FlexColumn } from 'src/components/flex';

import styles from 'src/components/page-header/PageHeader.module.css';

type PageHeaderProps = {
    title?: ReactNode;
    search?: ReactNode;
    controls?: ReactNode;
    filter?: ReactNode;
    sort?: ReactNode;
    actions?: ReactNode;
    status?: ReactNode;
};

export default function PageHeader({
    title,
    search,
    controls,
    filter,
    sort,
    actions,
    status,
}: PageHeaderProps) {
    return (
        <FlexColumn className={styles.root}>
            <Flex
                justifyContent="space-between"
                alignItems="flex-start"
                flexDirection="row"
                className={styles.topRow}
            >
                <Flex
                    flex={1}
                    minWidth={0}
                    alignItems="center"
                    flexWrap="nowrap"
                    className={styles.main}
                >
                    {title && (
                        <Typography
                            variant="h2"
                            component="h2"
                            className={styles.title}
                        >
                            {title}
                        </Typography>
                    )}
                    {search && (
                        <Flex minWidth={0} className={styles.searchWrap}>
                            {search}
                        </Flex>
                    )}
                    {controls && (
                        <Flex alignItems="center" className={styles.controls}>
                            {controls}
                        </Flex>
                    )}
                    {filter && (
                        <Flex alignItems="center" className={styles.filter}>
                            {filter}
                        </Flex>
                    )}
                    {sort && (
                        <Flex alignItems="center" className={styles.sort}>
                            {sort}
                        </Flex>
                    )}
                </Flex>

                {actions && (
                    <Flex alignItems="center" className={styles.actions}>
                        {actions}
                    </Flex>
                )}
            </Flex>

            {status && (
                <Flex alignItems="center" flexWrap="wrap" className={styles.status}>
                    {status}
                </Flex>
            )}
        </FlexColumn>
    );
}
